export default "__VITE_ASSET__cZWbLAq2__"